import _ from 'lodash';
import React from 'react';
import { Formik } from 'formik';

// Components
import { FormikSubmitRegistrar, StageSubmitRegistrar } from '../../_core/Formik/formik-submit-registrar.component';
import { GroupStageBuilder } from './group-stage-builder.component';
import { IGroupStageBuilderFormValues } from './group-stage-builder.interface';
import {
  buildOrderByOption,
  buildPlayerLimitOptions,
} from '../assessment-stage.constants';
import { IFormOption } from '../../_core/_ui/forms.component';
import { IAssessmentStageBuilderBaseProps } from '../assessment-stage.types';

interface GroupStageBuilderContainerProps extends IAssessmentStageBuilderBaseProps {
  stage: IAssessmentStage;
  updateStage: Function;
  positionOptions: IFormOption[];
  // Catalog stage settings derive playerLimits per band at apply time, so the limits
  // input hides and the key stays out of the submitted config.
  catalogSettingsMode?: boolean;
  registerStageSubmit?: StageSubmitRegistrar;
}

export const GroupStageBuilderContainer: React.FC<GroupStageBuilderContainerProps> = ({
  stage,
  updateStage,
  positionOptions,
  catalogSettingsMode,
  registerStageSubmit,
  style
}) => {
  const INITIAL_FORM_VALUES: IGroupStageBuilderFormValues = {
    orderBy: buildOrderByOption(stage.config.orderBy),
    playerLimits: buildPlayerLimitOptions(positionOptions, stage.config.playerLimits || []),
    manualApproval: _.isBoolean(stage.config.manualApproval) ? stage.config.manualApproval : true
  };

  async function handleSubmit(values: IGroupStageBuilderFormValues, { setSubmitting }: any) {
    setSubmitting(false);

    const config = {
      orderBy: values.orderBy.value,
      manualApproval: values.manualApproval,
      ...(!catalogSettingsMode && {
        playerLimits: values.playerLimits.map(playerLimit => ({ positions: playerLimit.positions.map(position => position.value), limit: playerLimit.limit })),
      }),
    }

    updateStage(stage._id, { config });
  }

  return (
    <Formik enableReinitialize initialValues={INITIAL_FORM_VALUES} onSubmit={handleSubmit}>
      {form => (
        <>
          <FormikSubmitRegistrar id={stage._id} register={registerStageSubmit} />
          <GroupStageBuilder
            form={form}
            stage={stage}
            positionOptions={[...positionOptions]}
            catalogSettingsMode={catalogSettingsMode}
            style={style}
          />
        </>
      )}
    </Formik>
  );
};
